/** How a task schedule reads. */
export default {
  once: "Once: {when}",
  daily: "Daily at {time}",
  weekdays: "Weekdays at {time}",
  weekly: "Weekly on {day} at {time}",
  biweekly: "Every 2 weeks on {day} at {time}",
  monthly: "Monthly on day {day} at {time}",
  scheduled: "Scheduled",
} as const;
